import { useQuery } from "@tanstack/react-query";

import { advancedSearchKeys } from "../modules/samples/queryKeys";
import api from "../services/api";

export const useUserConfig = () => {
  const userConfigQuery = useQuery({
    queryKey: advancedSearchKeys.fetchUserData,
    queryFn: () => api.getUserData(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    select: data => {
      const { search_columns = {}, ...rest } = data?.data || {};
      return {
        ...search_columns,
        ...rest
      };
    }
  });

  return {
    data: userConfigQuery?.data || {}
  };
};
